import { emptySplitApi as api } from './emptyApi';
export const addTagTypes = ['notifications'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      notificationsAllNotificationsList: build.query<
        NotificationsAllNotificationsListApiResponse,
        NotificationsAllNotificationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/all-notifications/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['notifications'],
      }),
      notificationsAllNotificationsRetrieve: build.query<
        NotificationsAllNotificationsRetrieveApiResponse,
        NotificationsAllNotificationsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/all-notifications/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['notifications'],
      }),
      notificationsAudiencesList: build.query<
        NotificationsAudiencesListApiResponse,
        NotificationsAudiencesListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/audiences/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['notifications'],
      }),
      notificationsAudiencesRetrieve: build.query<
        NotificationsAudiencesRetrieveApiResponse,
        NotificationsAudiencesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/audiences/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['notifications'],
      }),
      notificationsChannelsList: build.query<
        NotificationsChannelsListApiResponse,
        NotificationsChannelsListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/channels/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['notifications'],
      }),
      notificationsChannelsRetrieve: build.query<
        NotificationsChannelsRetrieveApiResponse,
        NotificationsChannelsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/channels/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['notifications'],
      }),
      notificationsMemberSettingsList: build.query<
        NotificationsMemberSettingsListApiResponse,
        NotificationsMemberSettingsListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/member-settings/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['notifications'],
      }),
      notificationsMemberSettingsCreate: build.mutation<
        NotificationsMemberSettingsCreateApiResponse,
        NotificationsMemberSettingsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/member-settings/`,
          method: 'POST',
          body: queryArg.notificationMemberSettings,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsMemberSettingsRetrieve: build.query<
        NotificationsMemberSettingsRetrieveApiResponse,
        NotificationsMemberSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/member-settings/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['notifications'],
      }),
      notificationsMemberSettingsPartialUpdate: build.mutation<
        NotificationsMemberSettingsPartialUpdateApiResponse,
        NotificationsMemberSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/member-settings/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedNotificationMemberSettings,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsNotificationsList: build.query<
        NotificationsNotificationsListApiResponse,
        NotificationsNotificationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            created_at: queryArg.createdAt,
            is_expired: queryArg.isExpired,
            is_read: queryArg.isRead,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            read_at: queryArg.readAt,
            seen_at: queryArg.seenAt,
          },
        }),
        providesTags: ['notifications'],
      }),
      notificationsNotificationsRetrieve: build.query<
        NotificationsNotificationsRetrieveApiResponse,
        NotificationsNotificationsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['notifications'],
      }),
      notificationsNotificationsPartialUpdate: build.mutation<
        NotificationsNotificationsPartialUpdateApiResponse,
        NotificationsNotificationsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedNotification,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsNotificationsCountRetrieve: build.query<
        NotificationsNotificationsCountRetrieveApiResponse,
        NotificationsNotificationsCountRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/count/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['notifications'],
      }),
      notificationsNotificationsMarkAllReadPartialUpdate: build.mutation<
        NotificationsNotificationsMarkAllReadPartialUpdateApiResponse,
        NotificationsNotificationsMarkAllReadPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/mark_all_read/`,
          method: 'PATCH',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsNotificationsMarkAllSeenPartialUpdate: build.mutation<
        NotificationsNotificationsMarkAllSeenPartialUpdateApiResponse,
        NotificationsNotificationsMarkAllSeenPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/mark_all_seen/`,
          method: 'PATCH',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsRoleSettingsList: build.query<
        NotificationsRoleSettingsListApiResponse,
        NotificationsRoleSettingsListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/role-settings/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['notifications'],
      }),
      notificationsRoleSettingsCreate: build.mutation<
        NotificationsRoleSettingsCreateApiResponse,
        NotificationsRoleSettingsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/role-settings/`,
          method: 'POST',
          body: queryArg.notificationRoleSettings,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsRoleSettingsRetrieve: build.query<
        NotificationsRoleSettingsRetrieveApiResponse,
        NotificationsRoleSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/role-settings/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['notifications'],
      }),
      notificationsRoleSettingsPartialUpdate: build.mutation<
        NotificationsRoleSettingsPartialUpdateApiResponse,
        NotificationsRoleSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/role-settings/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedNotificationRoleSettings,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['notifications'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as bambiApi };
export type NotificationsAllNotificationsListApiResponse =
  /** status 200  */ PaginatedNotificationListRead;
export type NotificationsAllNotificationsListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type NotificationsAllNotificationsRetrieveApiResponse =
  /** status 200  */ NotificationRead;
export type NotificationsAllNotificationsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this notification. */
  id: string;
};
export type NotificationsAudiencesListApiResponse =
  /** status 200  */ PaginatedNotificationAudienceListRead;
export type NotificationsAudiencesListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type NotificationsAudiencesRetrieveApiResponse =
  /** status 200  */ NotificationAudienceRead;
export type NotificationsAudiencesRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this notification audience. */
  id: string;
};
export type NotificationsChannelsListApiResponse =
  /** status 200  */ PaginatedNotificationChannelListRead;
export type NotificationsChannelsListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type NotificationsChannelsRetrieveApiResponse =
  /** status 200  */ NotificationChannelRead;
export type NotificationsChannelsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this notification channel. */
  id: string;
};
export type NotificationsMemberSettingsListApiResponse =
  /** status 200  */ PaginatedNotificationMemberSettingsListRead;
export type NotificationsMemberSettingsListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type NotificationsMemberSettingsCreateApiResponse =
  /** status 201  */ NotificationMemberSettingsRead;
export type NotificationsMemberSettingsCreateApiArg = {
  'Organization-ID'?: string;
  notificationMemberSettings: NotificationMemberSettings;
};
export type NotificationsMemberSettingsRetrieveApiResponse =
  /** status 200  */ NotificationMemberSettingsRead;
export type NotificationsMemberSettingsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this notification member settings. */
  id: string;
};
export type NotificationsMemberSettingsPartialUpdateApiResponse =
  /** status 200  */ NotificationMemberSettingsRead;
export type NotificationsMemberSettingsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this notification member settings. */
  id: string;
  patchedNotificationMemberSettings: PatchedNotificationMemberSettings;
};
export type NotificationsNotificationsListApiResponse =
  /** status 200  */ PaginatedNotificationListRead;
export type NotificationsNotificationsListApiArg = {
  'Organization-ID'?: string;
  createdAt?: string;
  isExpired?: boolean;
  isRead?: boolean;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  readAt?: string;
  seenAt?: string;
};
export type NotificationsNotificationsRetrieveApiResponse =
  /** status 200  */ NotificationRead;
export type NotificationsNotificationsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this notification. */
  id: string;
};
export type NotificationsNotificationsPartialUpdateApiResponse =
  /** status 200  */ NotificationRead;
export type NotificationsNotificationsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this notification. */
  id: string;
  patchedNotification: PatchedNotification;
};
export type NotificationsNotificationsCountRetrieveApiResponse =
  /** status 200  */ NotificationCount;
export type NotificationsNotificationsCountRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type NotificationsNotificationsMarkAllReadPartialUpdateApiResponse =
  /** status 204 No response body */ void;
export type NotificationsNotificationsMarkAllReadPartialUpdateApiArg = {
  'Organization-ID'?: string;
};
export type NotificationsNotificationsMarkAllSeenPartialUpdateApiResponse =
  /** status 204 No response body */ void;
export type NotificationsNotificationsMarkAllSeenPartialUpdateApiArg = {
  'Organization-ID'?: string;
};
export type NotificationsRoleSettingsListApiResponse =
  /** status 200  */ PaginatedNotificationRoleSettingsListRead;
export type NotificationsRoleSettingsListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type NotificationsRoleSettingsCreateApiResponse =
  /** status 201  */ NotificationRoleSettingsRead;
export type NotificationsRoleSettingsCreateApiArg = {
  'Organization-ID'?: string;
  notificationRoleSettings: NotificationRoleSettings;
};
export type NotificationsRoleSettingsRetrieveApiResponse =
  /** status 200  */ NotificationRoleSettingsRead;
export type NotificationsRoleSettingsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this notification role settings. */
  id: string;
};
export type NotificationsRoleSettingsPartialUpdateApiResponse =
  /** status 200  */ NotificationRoleSettingsRead;
export type NotificationsRoleSettingsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this notification role settings. */
  id: string;
  patchedNotificationRoleSettings: PatchedNotificationRoleSettings;
};
export type Notification = {
  /** Set when the member views/dismisses the notification in the web app. */
  seen_at?: string | null;
  read_at?: string | null;
};
export type NotificationTypeNameEnum =
  | 'credential_expiring_soon'
  | 'trip_subscription_expiring_soon'
  | 'public_trip_requested'
  | 'facility_trip_requested'
  | 'vehicle_failed_inspection'
  | 'facility_trip_accepted'
  | 'facility_trip_rejected';
export type NotificationRead = {
  id: string;
  ref_entity_type: string | null;
  ref_entity_id: string | null;
  notification_type_name: NotificationTypeNameEnum;
  /** Set when the member views/dismisses the notification in the web app. */
  seen_at?: string | null;
  read_at?: string | null;
  created_at: string;
};
export type PaginatedNotificationList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Notification[];
};
export type PaginatedNotificationListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: NotificationRead[];
};
export type ClientErrorEnum = 'client_error';
export type ParseErrorCodeEnum = 'parse_error';
export type ParseError = {
  code: ParseErrorCodeEnum;
  detail: string;
  attr: string | null;
};
export type ParseErrorResponse = {
  type: ClientErrorEnum;
  errors: ParseError[];
};
export type NotificationsAllNotificationsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type ErrorCode403Enum = 'permission_denied';
export type Error403 = {
  code: ErrorCode403Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse403 = {
  type: ClientErrorEnum;
  errors: Error403[];
};
export type ErrorCode404Enum = 'not_found';
export type Error404 = {
  code: ErrorCode404Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse404 = {
  type: ClientErrorEnum;
  errors: Error404[];
};
export type NotificationsAllNotificationsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type ResolverEnum =
  | 'trip_assignment_driver'
  | 'trip_assignment_attendants'
  | 'trip_assignment_assigned_memberships'
  | 'trip_created_by_membership';
export type BlankEnum = '';
export type RoleEnum =
  | 'owner'
  | 'admin'
  | 'dispatcher'
  | 'associate'
  | 'restricted support'
  | 'facility admin'
  | 'facility user'
  | 'bambi'
  | 'integration';
export type NotificationAudience = {
  id?: string;
  notification_type: string;
  /** Resolver key used to derive members from the event entity (see apps.notifications.resolvers.resolver_map). */
  resolver: ResolverEnum | BlankEnum;
  /** When specified, targets the members of a role within the organization */
  role: RoleEnum | BlankEnum;
};
export type NotificationAudienceRead = {
  id?: string;
  notification_type: string;
  notification_type_name: string;
  /** Resolver key used to derive members from the event entity (see apps.notifications.resolvers.resolver_map). */
  resolver: ResolverEnum | BlankEnum;
  /** When specified, targets the members of a role within the organization */
  role: RoleEnum | BlankEnum;
};
export type PaginatedNotificationAudienceList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: NotificationAudience[];
};
export type PaginatedNotificationAudienceListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: NotificationAudienceRead[];
};
export type NotificationsAudiencesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type NotificationsAudiencesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type NotificationChannel = {};
export type ChannelTypeEnum = 'email' | 'mobile_push' | 'web_push';
export type NotificationChannelRead = {
  id: string;
  channel_type: ChannelTypeEnum;
};
export type PaginatedNotificationChannelList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: NotificationChannel[];
};
export type PaginatedNotificationChannelListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: NotificationChannelRead[];
};
export type NotificationsChannelsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type NotificationsChannelsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type NotificationMemberSettings = {
  notification_type: string;
  channel: string;
  is_enabled?: boolean;
};
export type NotificationMemberSettingsRead = {
  id: string;
  notification_type: string;
  notification_type_name: string;
  channel: string;
  is_enabled?: boolean;
};
export type PaginatedNotificationMemberSettingsList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: NotificationMemberSettings[];
};
export type PaginatedNotificationMemberSettingsListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: NotificationMemberSettingsRead[];
};
export type NotificationsMemberSettingsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type ValidationErrorEnum = 'validation_error';
export type NotificationsMemberSettingsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type NotificationsMemberSettingsCreateNotificationTypeErrorComponent = {
  attr: 'notification_type';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type NotificationsMemberSettingsCreateChannelErrorComponent = {
  attr: 'channel';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type NotificationsMemberSettingsCreateIsEnabledErrorComponent = {
  attr: 'is_enabled';
  code: 'invalid' | 'null';
  detail: string;
};
export type NotificationsMemberSettingsCreateError =
  | ({
      attr: 'non_field_errors';
    } & NotificationsMemberSettingsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'notification_type';
    } & NotificationsMemberSettingsCreateNotificationTypeErrorComponent)
  | ({
      attr: 'channel';
    } & NotificationsMemberSettingsCreateChannelErrorComponent)
  | ({
      attr: 'is_enabled';
    } & NotificationsMemberSettingsCreateIsEnabledErrorComponent);
export type NotificationsMemberSettingsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: NotificationsMemberSettingsCreateError[];
};
export type NotificationsMemberSettingsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & NotificationsMemberSettingsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type NotificationsMemberSettingsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type NotificationsMemberSettingsPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type NotificationsMemberSettingsPartialUpdateNotificationTypeErrorComponent =
  {
    attr: 'notification_type';
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
  };
export type NotificationsMemberSettingsPartialUpdateChannelErrorComponent = {
  attr: 'channel';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type NotificationsMemberSettingsPartialUpdateIsEnabledErrorComponent = {
  attr: 'is_enabled';
  code: 'invalid' | 'null';
  detail: string;
};
export type NotificationsMemberSettingsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & NotificationsMemberSettingsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'notification_type';
    } & NotificationsMemberSettingsPartialUpdateNotificationTypeErrorComponent)
  | ({
      attr: 'channel';
    } & NotificationsMemberSettingsPartialUpdateChannelErrorComponent)
  | ({
      attr: 'is_enabled';
    } & NotificationsMemberSettingsPartialUpdateIsEnabledErrorComponent);
export type NotificationsMemberSettingsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: NotificationsMemberSettingsPartialUpdateError[];
};
export type NotificationsMemberSettingsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & NotificationsMemberSettingsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedNotificationMemberSettings = {
  notification_type?: string;
  channel?: string;
  is_enabled?: boolean;
};
export type PatchedNotificationMemberSettingsRead = {
  id?: string;
  notification_type?: string;
  notification_type_name?: string;
  channel?: string;
  is_enabled?: boolean;
};
export type NotificationsNotificationsListCreatedAtErrorComponent = {
  attr: 'created_at';
  code: 'invalid';
  detail: string;
};
export type NotificationsNotificationsListReadAtErrorComponent = {
  attr: 'read_at';
  code: 'invalid';
  detail: string;
};
export type NotificationsNotificationsListSeenAtErrorComponent = {
  attr: 'seen_at';
  code: 'invalid';
  detail: string;
};
export type NotificationsNotificationsListError =
  | ({
      attr: 'created_at';
    } & NotificationsNotificationsListCreatedAtErrorComponent)
  | ({
      attr: 'read_at';
    } & NotificationsNotificationsListReadAtErrorComponent)
  | ({
      attr: 'seen_at';
    } & NotificationsNotificationsListSeenAtErrorComponent);
export type NotificationsNotificationsListValidationError = {
  type: ValidationErrorEnum;
  errors: NotificationsNotificationsListError[];
};
export type NotificationsNotificationsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & NotificationsNotificationsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type NotificationsNotificationsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type NotificationsNotificationsPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type NotificationsNotificationsPartialUpdateSeenAtErrorComponent = {
  attr: 'seen_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type NotificationsNotificationsPartialUpdateReadAtErrorComponent = {
  attr: 'read_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type NotificationsNotificationsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & NotificationsNotificationsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'seen_at';
    } & NotificationsNotificationsPartialUpdateSeenAtErrorComponent)
  | ({
      attr: 'read_at';
    } & NotificationsNotificationsPartialUpdateReadAtErrorComponent);
export type NotificationsNotificationsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: NotificationsNotificationsPartialUpdateError[];
};
export type NotificationsNotificationsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & NotificationsNotificationsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedNotification = {
  /** Set when the member views/dismisses the notification in the web app. */
  seen_at?: string | null;
  read_at?: string | null;
};
export type PatchedNotificationRead = {
  id?: string;
  ref_entity_type?: string | null;
  ref_entity_id?: string | null;
  notification_type_name?: NotificationTypeNameEnum;
  /** Set when the member views/dismisses the notification in the web app. */
  seen_at?: string | null;
  read_at?: string | null;
  created_at?: string;
};
export type NotificationCount = {
  count: number;
};
export type NotificationsNotificationsCountRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type NotificationsNotificationsMarkAllReadPartialUpdateErrorResponse400 =
  {
    type: 'client_error';
  } & ParseErrorResponse;
export type NotificationsNotificationsMarkAllSeenPartialUpdateErrorResponse400 =
  {
    type: 'client_error';
  } & ParseErrorResponse;
export type NotificationRoleSettings = {
  notification_type: string;
  /** e.g. 'dispatcher', 'associate' */
  role: RoleEnum;
  is_enabled?: boolean;
};
export type NotificationRoleSettingsRead = {
  id: string;
  notification_type: string;
  notification_type_name: string;
  /** e.g. 'dispatcher', 'associate' */
  role: RoleEnum;
  is_enabled?: boolean;
};
export type PaginatedNotificationRoleSettingsList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: NotificationRoleSettings[];
};
export type PaginatedNotificationRoleSettingsListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: NotificationRoleSettingsRead[];
};
export type NotificationsRoleSettingsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type NotificationsRoleSettingsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type NotificationsRoleSettingsCreateNotificationTypeErrorComponent = {
  attr: 'notification_type';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type NotificationsRoleSettingsCreateRoleErrorComponent = {
  attr: 'role';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type NotificationsRoleSettingsCreateIsEnabledErrorComponent = {
  attr: 'is_enabled';
  code: 'invalid' | 'null';
  detail: string;
};
export type NotificationsRoleSettingsCreateError =
  | ({
      attr: 'non_field_errors';
    } & NotificationsRoleSettingsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'notification_type';
    } & NotificationsRoleSettingsCreateNotificationTypeErrorComponent)
  | ({
      attr: 'role';
    } & NotificationsRoleSettingsCreateRoleErrorComponent)
  | ({
      attr: 'is_enabled';
    } & NotificationsRoleSettingsCreateIsEnabledErrorComponent);
export type NotificationsRoleSettingsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: NotificationsRoleSettingsCreateError[];
};
export type NotificationsRoleSettingsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & NotificationsRoleSettingsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type NotificationsRoleSettingsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type NotificationsRoleSettingsPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type NotificationsRoleSettingsPartialUpdateNotificationTypeErrorComponent =
  {
    attr: 'notification_type';
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
  };
export type NotificationsRoleSettingsPartialUpdateRoleErrorComponent = {
  attr: 'role';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type NotificationsRoleSettingsPartialUpdateIsEnabledErrorComponent = {
  attr: 'is_enabled';
  code: 'invalid' | 'null';
  detail: string;
};
export type NotificationsRoleSettingsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & NotificationsRoleSettingsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'notification_type';
    } & NotificationsRoleSettingsPartialUpdateNotificationTypeErrorComponent)
  | ({
      attr: 'role';
    } & NotificationsRoleSettingsPartialUpdateRoleErrorComponent)
  | ({
      attr: 'is_enabled';
    } & NotificationsRoleSettingsPartialUpdateIsEnabledErrorComponent);
export type NotificationsRoleSettingsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: NotificationsRoleSettingsPartialUpdateError[];
};
export type NotificationsRoleSettingsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & NotificationsRoleSettingsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedNotificationRoleSettings = {
  notification_type?: string;
  /** e.g. 'dispatcher', 'associate' */
  role?: RoleEnum;
  is_enabled?: boolean;
};
export type PatchedNotificationRoleSettingsRead = {
  id?: string;
  notification_type?: string;
  notification_type_name?: string;
  /** e.g. 'dispatcher', 'associate' */
  role?: RoleEnum;
  is_enabled?: boolean;
};
export const {
  useNotificationsAllNotificationsListQuery,
  useLazyNotificationsAllNotificationsListQuery,
  useNotificationsAllNotificationsRetrieveQuery,
  useLazyNotificationsAllNotificationsRetrieveQuery,
  useNotificationsAudiencesListQuery,
  useLazyNotificationsAudiencesListQuery,
  useNotificationsAudiencesRetrieveQuery,
  useLazyNotificationsAudiencesRetrieveQuery,
  useNotificationsChannelsListQuery,
  useLazyNotificationsChannelsListQuery,
  useNotificationsChannelsRetrieveQuery,
  useLazyNotificationsChannelsRetrieveQuery,
  useNotificationsMemberSettingsListQuery,
  useLazyNotificationsMemberSettingsListQuery,
  useNotificationsMemberSettingsCreateMutation,
  useNotificationsMemberSettingsRetrieveQuery,
  useLazyNotificationsMemberSettingsRetrieveQuery,
  useNotificationsMemberSettingsPartialUpdateMutation,
  useNotificationsNotificationsListQuery,
  useLazyNotificationsNotificationsListQuery,
  useNotificationsNotificationsRetrieveQuery,
  useLazyNotificationsNotificationsRetrieveQuery,
  useNotificationsNotificationsPartialUpdateMutation,
  useNotificationsNotificationsCountRetrieveQuery,
  useLazyNotificationsNotificationsCountRetrieveQuery,
  useNotificationsNotificationsMarkAllReadPartialUpdateMutation,
  useNotificationsNotificationsMarkAllSeenPartialUpdateMutation,
  useNotificationsRoleSettingsListQuery,
  useLazyNotificationsRoleSettingsListQuery,
  useNotificationsRoleSettingsCreateMutation,
  useNotificationsRoleSettingsRetrieveQuery,
  useLazyNotificationsRoleSettingsRetrieveQuery,
  useNotificationsRoleSettingsPartialUpdateMutation,
} = injectedRtkApi;
